import React, { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";
import { useConfirm } from "@/components/ConfirmDialog";

export function AuthorizedRncTab() {
  const [rows, setRows] = useState([]);
  const [f, setF] = useState({ rnc: "", name: "", reason: "" });
  const confirm = useConfirm();
  const load = async () => setRows((await api.get("/fiscal/e44-authorized")).data);
  useEffect(() => { load(); }, []);
  const add = async () => {
    try { await api.post("/fiscal/e44-authorized", f); toast.success("RNC autorizado para E44"); setF({ rnc: "", name: "", reason: "" }); load(); }
    catch (e) { toast.error(formatApiError(e)); }
  };
  return (
    <div className="space-y-3">
      <p className="text-sm text-muted-foreground">RNC autorizados para recibir E44. Se validan con el padrón DGII (activo y razón social igual).</p>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-2">
        <Input placeholder="RNC" value={f.rnc} onChange={(e) => setF({ ...f, rnc: e.target.value })} data-testid="auth-rnc-input" />
        <Input placeholder="Razón social" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="auth-name-input" />
        <Input placeholder="Motivo / resolución" value={f.reason} onChange={(e) => setF({ ...f, reason: e.target.value })} data-testid="auth-reason-input" />
        <Button onClick={add} className="bg-primary font-bold" data-testid="auth-add-btn"><Plus className="w-4 h-4 mr-1" />Autorizar</Button>
      </div>
      <table className="w-full text-sm border border-border rounded-md" data-testid="auth-rnc-table">
        <thead className="overline border-b"><tr><th className="p-2 text-left">RNC</th><th className="p-2 text-left">Razón social</th><th className="p-2 text-left">Motivo</th><th className="p-2 text-left">Por</th><th /></tr></thead>
        <tbody>{rows.map((r) => (
          <tr key={r.rnc} className="border-b border-border/60">
            <td className="p-2 font-mono">{r.rnc}</td><td className="p-2">{r.name}</td><td className="p-2 text-xs">{r.reason}</td><td className="p-2 text-xs">{r.by}</td>
            <td className="p-2 text-right"><Button size="icon" variant="ghost" onClick={async () => { if (!(await confirm({ title: "¿Quitar RNC autorizado?", description: `${r.rnc} ya no podrá recibir E44 por esta lista.`, confirmLabel: "Quitar", destructive: true }))) return; await api.delete(`/fiscal/e44-authorized/${r.rnc}`); load(); }} data-testid={`auth-del-${r.rnc}`}><Trash2 className="w-4 h-4" /></Button></td>
          </tr>))}
          {rows.length === 0 && <tr><td colSpan={5} className="p-6 text-center text-muted-foreground">Sin RNC autorizados</td></tr>}
        </tbody>
      </table>
    </div>
  );
}
